import { FormGroup, NgForm } from "@angular/forms";
import * as ps from "perfect-scrollbar";

/**
 * Created by alex.y on 9/15/2017.
 */
export class FormHelper {
    /**
     * mark all form controlls as dirty
     * and validate form
     * @param form
     */
    public static markControllsAsDirty(form: NgForm): void {
        Object.keys(form.controls).forEach(key => {
            form.controls[key].markAsDirty();
            form.controls[key].markAsTouched();
            form.controls[key].updateValueAndValidity();
        });
    }

    public static isFromValid(form: NgForm): boolean {
        this.markControllsAsDirty(form);
        //  form.updateValueAndValidity();
        return form.valid;
    }

    public static scrollToTopCalcV2() { // todo Refactor
        const el = document.querySelector(".public-calc");

        if (el) {
            el.scrollTop = 0
        }

    }
    
    public static scrollToCalcV2TabOnMobile(): void{
        if(window.orientation != undefined) {
            setTimeout( ()=>{
                if(window.navigator.platform == "iPhone"){
                    document.body.scrollTop = 0;
                    document.body.scrollIntoView(true);
                }else{
                    let el = document.querySelector('.public-calc');
                    el.scrollTop = 0;
                    el.scrollIntoView(true);
                }
            }, 100)
        }
    }
}



// WEBPACK FOOTER //
// ./app/common/helpers/formHelper.ts